const popupSlider = document.querySelector( '[data-popup-slider]' );
const popupSliderCards = popupSlider?.querySelectorAll( '[data-card]' ) ?? [];
const popupSliderCardsArray = Array.from( popupSliderCards );
const initialActiveCard = popupSliderCardsArray.length > 0 ? popupSliderCardsArray[0].querySelector( '.card-container' ) : null;
const openers = document.querySelectorAll( '.slider-popup-info .card-button' );
const infoBox = popupSlider?.querySelector( '.info-box' );
const popupSliderSlider = popupSlider?.querySelector( '.slider-popup-info-slider' );

const titleSlot = infoBox?.querySelector( '[data-slot-title]' );
const contentSlot = infoBox?.querySelector( '[data-slot-content]' );
const imageSlot = infoBox?.querySelector( '[data-slot-image]' );
const locationSlot = infoBox?.querySelector( '[data-slot-location]' );
const keyPointSlot = infoBox?.querySelector( '[data-slot-key-point]' );
const rolesSlot = infoBox?.querySelector( '[data-slot-roles]' );
const buttonSlot = infoBox?.querySelector( '[data-vacancy-id]' );


initialActiveCard?.classList.add( 'active' );

openers.forEach( opener => {
    opener.addEventListener( 'click', openInfo );
} );

function openInfo( event ) {
    document.querySelectorAll( '.card-container.active' ).forEach( card => {
        card.classList.remove( 'active' );
    } );

    const activeCard = event.target.closest( '.card-container' );
    activeCard?.classList.add( 'active' );

    titleSlot.innerHTML = event.target.getAttribute( 'data-title' );
    contentSlot.innerHTML = event.target.getAttribute( 'data-content' );
    imageSlot.innerHTML = event.target.getAttribute( 'data-image' );
    locationSlot.innerHTML = `<strong>Location:</strong> ${event.target.getAttribute( 'data-location' )}`;
    buttonSlot?.setAttribute( 'data-vacancy-id', event.target.getAttribute( 'data-id' ) );
    const keyPoints = event.currentTarget.getAttribute( 'data-key-point' );
    if ( keyPoints ) {
        const keyPointsArray = JSON.parse( keyPoints );
        let keyPointsHTML = '';
        keyPointsArray.forEach( keyPoint => {
            keyPointsHTML += `<div class="flex items-start gap-2 mt-4" data-slot-key-point>
                                <svg class="text-light translate-y-[-5px] min-h-8 shrink-0" xmlns="http://www.w3.org/2000/svg" width="19.579" height="15.262" viewBox="0 0 19.579 15.262">
                                    <path id="Path_411" data-name="Path 411" d="M-7071.863-239.028l5.731,5.731,11.019-11.019" transform="translate(7073.277 245.73)" fill="none" stroke="currentColor" stroke-width="4" />
                                </svg>
                                <b>${keyPoint.point}</b>
                              </div>`;
        } );
        keyPointSlot.innerHTML = keyPointsHTML;
    } else {
        keyPointSlot.innerHTML = ''; // Clear the key points slot if no key points are available
    }
    const roles = event.currentTarget.getAttribute( 'data-roles' );
    if ( roles && roles !== 'null' ) {
        const rolesArray = JSON.parse( roles );
        let rolesHTML = '';
        rolesArray.forEach( role => {
            rolesHTML += `<div class="flex items-start gap-2 mt-4" data-slot-roles>
                                <svg class="text-light translate-y-[-5px] min-h-8 shrink-0" xmlns="http://www.w3.org/2000/svg" width="19.579" height="15.262" viewBox="0 0 19.579 15.262">
                                    <path id="Path_411" data-name="Path 411" d="M-7071.863-239.028l5.731,5.731,11.019-11.019" transform="translate(7073.277 245.73)" fill="none" stroke="currentColor" stroke-width="4" />
                                </svg>
                                <b>${role.role}</b>
                              </div>`;
        } );
        rolesSlot.innerHTML = rolesHTML;

    } else {
        rolesSlot.innerHTML = ''; // Clear the roles slot if roles are available
    }
}


jQuery( popupSliderSlider ).on( 'afterChange', function( event, slick, currentSlide ) {
    popupSliderCards[currentSlide].querySelector( '.card-button' )?.click();
} );
